const steps = [
  {
    number: "01",
    title: "Initial Consultation",
    desc: "Share your matter with us. Confidential, no obligation.",
  },
  {
    number: "02",
    title: "Case Assessment",
    desc: "Our partners evaluate your situation and outline the strategy.",
  },
  {
    number: "03",
    title: "Engagement",
    desc: "We formalise the engagement and begin work immediately.",
  },
  {
    number: "04",
    title: "Resolution",
    desc: "We pursue the best outcome — in the boardroom or the courtroom.",
  },
];

export default function ProcessTimeline() {
  return (
    <section data-testid="process-section" className="py-24 md:py-32 bg-navy-dark">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="mb-16 animate-on-scroll">
          <p className="text-sm tracking-[0.3em] uppercase text-gold font-body font-medium mb-4">
            How It Works
          </p>
          <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl tracking-tight text-white">
            Your path to resolution.
          </h2>
          <div className="h-px w-16 bg-gold/40 mt-6" />
        </div>

        <div className="grid md:grid-cols-4 gap-8 relative">
          {/* Connecting line on desktop */}
          <div className="hidden md:block absolute top-10 left-10 right-[calc(25%-64px)] h-px bg-gold/20" />

          {steps.map((step, i) => (
            <div key={step.number} data-testid={`process-step-${i}`} className="animate-on-scroll relative text-center md:text-left">
              {/* Step number circle */}
              <div className="inline-flex items-center justify-center w-20 h-20 border border-gold/30 mb-6 relative bg-navy-dark">
                <span className="font-heading text-2xl text-gold">{step.number}</span>
              </div>
              <h3 className="font-heading text-xl md:text-2xl text-white tracking-tight mb-2">
                {step.title}
              </h3>
              <p className="text-sm text-gray-400 font-body leading-relaxed">{step.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
